var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 104,
    viewBox: "0 0 119 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.16 35.42C71.79 35.42 63.27 35.08 55.3 32.86C47.48 30.69 40.3 26.48 33.9 21.61C29.71 18.44 25.9 15.92 20.46 16.3C15.1335 16.5916 10.0424 18.5902 5.93999 22C-0.980006 28 0.0599933 39.23 2.82999 47.12C6.98999 59 19.65 67.23 30.41 72.61C42.84 78.82 56.5 82.42 70.19 84.5C82.19 86.32 97.61 87.65 108.01 79.81C117.56 72.61 120.18 56.17 117.84 45.07C117.273 41.7879 115.527 38.8258 112.93 36.74C106.22 31.84 96.21 35.11 88.67 35.28C85.87 35.34 83.02 35.41 80.16 35.42Z",
    fill: "#E6F2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.68 103.95C79.9544 103.95 96.39 102.925 96.39 101.66C96.39 100.395 79.9544 99.37 59.68 99.37C39.4056 99.37 22.97 100.395 22.97 101.66C22.97 102.925 39.4056 103.95 59.68 103.95Z",
    fill: "#E6F2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2306 5.12188L29.6956 25.5426C27.7477 26.2462 26.739 28.3957 27.4426 30.3436L39.3702 63.3654C40.0738 65.3133 42.2233 66.322 44.1712 65.6184L100.706 45.1977C102.654 44.4941 103.663 42.3446 102.959 40.3967L91.0315 7.37489C90.3279 5.42699 88.1785 4.41829 86.2306 5.12188Z",
    fill: "#CCE499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.91 83.26C43.4512 83.26 43.89 82.8212 43.89 82.28C43.89 81.7387 43.4512 81.3 42.91 81.3C42.3688 81.3 41.93 81.7387 41.93 82.28C41.93 82.8212 42.3688 83.26 42.91 83.26Z",
    fill: "#E6F2CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.93 2.78001C69.4713 2.78001 69.91 2.34125 69.91 1.80001C69.91 1.25877 69.4713 0.820007 68.93 0.820007C68.3888 0.820007 67.95 1.25877 67.95 1.80001C67.95 2.34125 68.3888 2.78001 68.93 2.78001Z",
    fill: "#E6F2CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 9.10999V13.42",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.54 11.27H43.85",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.93 25.04V29.34",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.77 27.19H107.08",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3876 27.0737L28.944 36.0001C26.8959 36.3076 25.4849 38.2173 25.7925 40.2654L31.0063 74.9861C31.3139 77.0342 33.2235 78.4452 35.2716 78.1376L94.7151 69.2113C96.7632 68.9038 98.1743 66.9941 97.8667 64.946L92.6529 30.2253C92.3453 28.1772 90.4357 26.7662 88.3876 27.0737Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.859 32.5847L79.8551 33.3361C79.0195 33.4616 78.4438 34.2408 78.5693 35.0764L79.3207 40.0803C79.4462 40.9159 80.2253 41.4916 81.0609 41.3661L86.0648 40.6147C86.9004 40.4892 87.4761 39.7101 87.3506 38.8745L86.5992 33.8706C86.4738 33.0349 85.6946 32.4593 84.859 32.5847Z",
    fill: "#80BC00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.152 62.5778L36.526 64.7741C36.0672 64.843 35.7511 65.2707 35.82 65.7295L35.8854 66.1646C35.9543 66.6234 36.382 66.9394 36.8408 66.8706L51.4668 64.6742C51.9256 64.6053 52.2416 64.1776 52.1728 63.7188L52.1074 63.2837C52.0385 62.8249 51.6108 62.5089 51.152 62.5778Z",
    fill: "#80BC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.04 65.383L37.3754 68.9366C36.7964 69.0235 36.3976 69.5633 36.4845 70.1422C36.5715 70.7212 37.1113 71.12 37.6902 71.0331L61.3549 67.4795C61.9338 67.3925 62.3326 66.8527 62.2457 66.2738C62.1588 65.6949 61.619 65.296 61.04 65.383Z",
    fill: "#80BC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCards);
export default __webpack_public_path__ + "static/media/empty-cards.945c5ad81ab306f75fc1419d4bf07d63.svg";
export { ForwardRef as ReactComponent };